/**
 * Trigger confirmation when user accepts/rejects
 */

$(document).on('click', '#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection, #CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll', function() {
    var $confirmation = $('<div />').addClass('cookie-accept-confirmation').append(
        $('<div />').addClass('content-wrapper').append(
            $('<h2 />').text(window.hastens_globals.cookieAcceptHeading),
            $('<p />').text(window.hastens_globals.cookieAcceptBody),
        ),
    );

    $('body').append($confirmation);
    setTimeout(function() {
        $confirmation.fadeOut(400, function() {
            $confirmation.remove();
        });
    }, 4000);
});

window.addEventListener('CookiebotOnAccept', function() {
    if (window.Cookiebot && window.Cookiebot.consent.marketing) {
        var existing = document.cookie.split(';').some(function(c) {
            return c.trim().indexOf('firstInteractionPoint=') === 0;
        });
        if (!existing) {
            var date = new Date();
            date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
            var expires = 'expires=' + date.toUTCString();
            document.cookie = 'firstInteractionPoint=' + encodeURIComponent(window.location.href) + ';' + expires + ';path=/;SameSite=Strict;Secure';
        }
    }
}, false);

$(document).on('click', '#CybotCookiebotDialogBodyButtonDecline', function() {
    var $confirmation = $('<div />').addClass('cookie-reject-confirmation').append(
        $('<div />').addClass('content-wrapper').append(
            $('<h2 />').text(window.hastens_globals.cookieRejectHeading),
            $('<p />').text(window.hastens_globals.cookieRejectBody),
        ),
    );

    $('body').append($confirmation);
    setTimeout(function() {
        $confirmation.fadeOut(400, function() {
            $confirmation.remove();
        });
    }, 4000);
});
